const GrPrizes = () => {
  return (
    <>
      <section>
        <p>
          Ανατρέξτε στις πληροφορίες «Πώς να παίξετε» που βρίσκονται στον
          ιστότοπο (
          <a
            href="https://gr.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://gr.nbafantasy.nba.com/help/rules
          </a>
          ) για πλήρεις λεπτομέρειες σχετικά με τη συσσώρευση πόντων.
        </p>
        <p>Θα υπάρξουν συνολικά 30 νικητές του Διαγωνισμού ως εξής:</p>
        <p>Για όλη τη σεζόν</p>
        <p>
          Θα απονεμηθούν έπαθλα στους πέντε (5) κορυφαίους Συμμετέχοντες με τους
          περισσότερους πόντους αθροιστικά στη διάρκεια της αγωνιστικής
          περιόδου. Προς αποφυγή αμφιβολιών, θα υπάρχουν πέντε (5) Βραβεία προς
          διεκδίκηση συνολικά, ΟΧΙ πέντε (5) Βραβεία για κάθε χώρα.
        </p>
        <p>
          Ένα (1) έπαθλο θα απονέμεται κάθε εβδομάδα [είκοσι πέντε (25)
          συνολικά] στον Συμμετέχοντα με τους περισσότερους πόντους σε μια
          συγκεκριμένη εβδομάδα. Προς αποφυγή αμφιβολιών, θα υπάρχει ένα (1)
          εβδομαδιαίο Βραβείο προς διεκδίκηση συνολικά, ΟΧΙ ένα (1) εβδομαδιαίο
          Βραβείο για κάθε χώρα.
        </p>
        <p>
          Σε περίπτωση ισοβαθμίας μεταξύ Συμμετεχόντων είτε για τα Βραβεία όλης
          της σεζόν είτε για ένα εβδομαδιαίο Βραβείο, θα εφαρμοστεί μέθοδος
          επίλυσης ισοβαθμίας για τον καθορισμό του Νικητή. Η ισοβαθμία θα
          επιλυθεί εξετάζοντας ποιος Συμμετέχων εισήλθε και δημιούργησε πρώτος
          την ομάδα του (προγενέστερη ημερομηνία) με βάση τα δεδομένα που
          συλλέγει ο Χορηγός.
        </p>
      </section>
      <section>
        <h3>Μεγάλο Βραβείο: πρώτη (1η) θέση συνολικά</h3>
        <p>
          Θα υπάρξει ένας (1) Νικητής του Μεγάλου Βραβείου («Νικητής του Μεγάλου
          Βραβείου»), το οποίο θα απονεμηθεί στον Συμμετέχοντα που θα έχει
          συσσωρεύσει τους περισσότερους πόντους στη διάρκεια του Διαγωνισμού.
        </p>
        <p>Το «Μεγάλο Βραβείο» περιλαμβάνει:</p>
        <ul>
          <li>
            <p>
              Μεταφορά από την κατοικία του Νικητή στο Παρίσι (Γαλλία) είτε με
              χρήση δύο (2) αεροπορικών εισιτηρίων οικονομικής θέσης μετ'
              επιστροφής προς ένα αεροδρόμιο του Παρισιού από το διεθνές
              αεροδρόμιο πλησιέστερα στην κατοικία του Νικητή, είτε με χρήση
              εισιτηρίων τρένου μετ' επιστροφής προς το Παρίσι από τον σταθμό
              πλησιέστερα στην κατοικία του Νικητή (κάτι που θα ορίσει και θα
              κοινοποιήσει ο Χορηγός κατά την αποκλειστική του κρίση).
            </p>
            <ul>
              <li>
                <p>
                  Η επιλογή συγκεκριμένης θέσης βρίσκεται στην αποκλειστική
                  κρίση του Χορηγού.
                </p>
              </li>
              <li>
                <p>
                  Ο ακριβής τρόπος μεταφοράς, οι ημερομηνίες και οι ώρες θα
                  καθοριστούν από τον Χορηγό κατά την αποκλειστική του κρίση
                </p>
              </li>
            </ul>
          </li>

          <li>
            <p>
              Ένα (1) δωμάτιο ξενοδοχείου για δύο (2) άτομα στο Παρίσι, για
              συνολικά τρεις (3) διανυκτερεύσεις σε ξενοδοχείο 3-4 αστέρων
            </p>
            <ul>
              <li>
                <p>
                  Τα ξενοδοχεία, τα δωμάτια και οι ημερομηνίες θα επιλεγούν από
                  τον Χορηγό κατά την αποκλειστική του κρίση
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Δύο (2) εισιτήρια αγώνων για έναν (1) αγώνα NBA στο Παρίσι κατά τη
              διάρκεια της αγωνιστικής περιόδου 2027-28 του NBA (ο "Αγώνας")
            </p>
            <ul>
              <li>
                <p>
                  Η ακριβής ημερομηνία του Αγώνα εναπόκειται στην αποκλειστική
                  κρίση του Χορηγού
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Ένα τρόπαιο Πρώτης Θέσης, το οποίο θα παραδοθεί διά ζώσης ή μέσω
              κούριερ στη διεύθυνση του νικητή, όπως αποφασίσει κατά την
              αποκλειστική κρίση του ο Χορηγός.
            </p>
          </li>
        </ul>
        <p>
          Η κατά προσέγγιση συνολική αθροιστική λιανική αξία του Μεγάλου
          Βραβείου είναι 2.500,00 €.
        </p>
        <p>
          Ο Νικητής μπορεί να υποδείξει έναν (1) φίλο ή συγγενή για να παραστεί
          μαζί του («Καλεσμένος»).
        </p>
        <p>
          Οι νικητές του Μεγάλου Βραβείου από οποιαδήποτε προηγούμενη σεζόν δεν
          έχουν δικαίωμα να διεκδικήσουν το Μεγάλο Βραβείο. Σε τέτοιες
          περιπτώσεις, το Μεγάλο Βραβείο θα απονεμηθεί στον επόμενο Συμμετέχοντα
          που πληροί τις προϋποθέσεις και ο νικητής του Μεγάλου Βραβείου που δεν
          πληροί τις προϋποθέσεις θα λάβει αντ' αυτού το έπαθλο της δεύτερης
          (2ης) θέσης.
        </p>
      </section>
      <section>
        <p>
          Τέσσερα (4) πρόσθετα, Δευτερεύοντα Βραβεία: δεύτερη (2η) έως πέμπτη
          (5η) θέση συνολικά Αυτά τα τέσσερα (4) πρόσθετα, Δευτερεύοντα Βραβεία
          θα απονεμηθούν στους Συμμετέχοντες που θα βρίσκονται στη δεύτερη (2η),
          τρίτη (3η), τέταρτη (4η) και πέμπτη (5η) θέση ως προς τη συσσώρευση
          πόντων στη διάρκεια του Διαγωνισμού (ατομικά, «Νικητής Δευτερεύοντος
          Βραβείου»).
        </p>
        <ul>
          <li>
            <p>
              Βραβείο δεύτερης (2ης) θέσης: Κάρτα δώρου NBA Store των 200,00 €
              για το{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Βραβείο τρίτης (3ης) θέσης: Κάρτα δώρου NBA Store των 200,00 € για
              το{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Βραβείο τέταρτης (4ης) θέσης: Κάρτα δώρου NBA Store των 200,00 €
              για το{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Βραβείο πέμπτης (5ης) θέσης: Κάρτα δώρου NBA Store των 200,00 €
              για το{" "}
              <a
                href="https://nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h3>Εβδομαδιαία:</h3>
        <p>
          Είκοσι πέντε (25) επιπλέον Βραβεία θα απονεμηθούν στους Συμμετέχοντες
          με τους περισσότερους πόντους κάθε εβδομάδας (ατομικά, «Νικητής
          Εβδομαδιαίου Βραβείου»). Ένα (1) Εβδομαδιαίο Βραβείο θα απονέμεται
          κάθε εβδομάδα από τις 25 συνολικά εβδομάδες που διαρκεί ο Διαγωνισμός.
        </p>
        <p>
          Το Εβδομαδιαίο Έπαθλο θα αποτελείται από ένα Ψηφιακό Αντίγραφο του NBA
          2K27 και μια δωροκάρτα από το NBA Store αξίας 100,00 € στη διεύθυνση{" "}
          <a
            href="https://nbastore.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://nbastore.eu
          </a>{" "}
          (θα καθοριστεί από τον Χορηγό κατά την απόλυτη κρίση του). Η κατά
          προσέγγιση συνολική αθροιστική αξία λιανικής πώλησης ενός Εβδομαδιαίου
          Βραβείου είναι 150,00 €.
        </p>
        <p>
          Για να έχουν δικαίωμα να κερδίσουν τα Εβδομαδιαία Βραβεία, οι χρήστες
          πρέπει να έχουν συμμετάσχει στο παιχνίδι είτε πριν από την έναρξη της
          σεζόν είτε τουλάχιστον 14 ημέρες πριν από την έναρξη της αντίστοιχης
          εβδομάδας του παιχνιδιού.
        </p>
        <p>
          Πλήρης λίστα των εβδομάδων του παιχνιδιού διατίθεται στην ενότητα{" "}
          <a
            href="https://gr.nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            Πώς να παίξετε
          </a>
          . Οι εβδομάδες του παιχνιδιού ενδέχεται να αλλάξουν κατά την
          αποκλειστική κρίση του Χορηγού.
        </p>
      </section>
    </>
  );
};
export { GrPrizes };
